export default __webpack_public_path__ + "static/media/blacklisted-red.94b20572.svg";